module.exports = __webpack_public_path__ + "static/img/participants.814e12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/participants.png
// module id = SNlL
// module chunks = 1